import * as AuthConstants from '../constants/Auth';

export function triggerForbidden() {
  return {
    type: AuthConstants.FORBIDDEN_TRIGGERED
  };
}

export function resetForbidden() {
  return {
    type: AuthConstants.FORBIDDEN_RESET
  };
}
